import { all, spawn } from 'redux-saga/effects';
import { initFlow } from 'sagas/initSagas';
import { watchRouterRequests } from 'sagas/routerSagas';
import { watchUserRequests } from 'sagas/userSagas';
import { watchDataRequests } from 'sagas/dataSagas';
import { watchUIRequests } from 'sagas/uiSagas';

export default function* root() {
    yield all([
        spawn(initFlow),
        spawn(watchRouterRequests),
        spawn(watchUIRequests),
        spawn(watchUserRequests),
        spawn(watchDataRequests),
    ]);
}
